import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id E86BFC0D-B4A4-41F2-A8E3-D1AE79072A45
 * name star-half
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-half.svg
 * tags
 * - Shape 
 */
export const StarHalfIcon = createSvgIcon(<><path d="M12 2L9.19 8.62L2 9.24L7.45 13.97L5.82 21L12 17.27V2Z" /></>, 'StarHalfIcon');
export default StarHalfIcon